import { DialogContent, DialogTitle, TextField } from "@mui/material";
import styles from "./dashboard.module.css";
import { ArrowLeft, X } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";

const schema = yup.object().shape({
    move_out_date: yup.string().required("This field is required").nullable(),
});

const LeavingForm = ({ setOpenLeavingFormModal, item, saveMoveOutDate }) => {
    const { handleSubmit, control, errors } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            move_out_date: item?.move_out_date ? dayjs(item?.move_out_date) : null,
        },
    });

    const onSubmit = async (data) => {
        saveMoveOutDate(dayjs(data.move_out_date).format("YYYY-MM-DD"));
    };

    return (<>
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenLeavingFormModal(false)}><ArrowLeft /></button>
            <span>Mark Tenant as Leaving</span>
            <button onClick={(e) => setOpenLeavingFormModal(false)}><X /></button>
        </DialogTitle>
        <DialogContent>
            <div className={`${styles.ProfileCardEditSec}`}>
                <p className={`${styles.OfferTemplatePopupText}`}>
                    {item?.tenant_name
                        ? `Set the move-out date for ${item.tenant_name}. This will show a Leaving badge with the selected date on the tenant list.`
                        : "Set the move-out date for this tenant."}
                </p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className={`${styles.ProfileEditFormSec}`}>
                            <div className={`${styles.EditFormFullSec} FormGroup`}>
                                <Controller
                                    name="move_out_date"
                                    control={control}
                                    render={(field) => (
                                        <DatePicker
                                            {...field}
                                            label="Move-out Date*"
                                            renderInput={(params) => (<TextField {...params} fullWidth />)}
                                        />
                                    )}
                                />
                                {errors.move_out_date && (<p className={`${styles.ErrorM}`}>{errors.move_out_date.message}</p>)}
                            </div>
                        </div>
                        <div className={`${styles.ButtonArea}`}>
                            <button className={`${styles.ButtonVoiletLine}`} type="button" onClick={(e) => setOpenLeavingFormModal(false)}>Cancel</button>
                            <button className={`${styles.ButtonVoiletSolid}`} type="submit">Save</button>
                        </div>
                    </LocalizationProvider>
                </form>
            </div>
        </DialogContent>
    </>);
};

export default LeavingForm;